/**
 * A directive that prevents an element that uses ngModel from
 * setting the form to dirty.
 */
export function NoDirtyCheckDirective() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function(scope, el, attr, ngModel) {
            // Override the $setDirty method on the ngModel controller instance
            // so that it doesn't do anything.
            ngModel.$setDirty = () => {};
        }
    }
}
